"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _moment = _interopRequireDefault(require("moment")),
    _uiKit = require("@devsta/ui-kit");

require("../styles/_activity-item.scss");

function ActivityItem(_ref) {
  var user = _ref.user,
      action = _ref.action,
      createdAt = _ref.createdAt,
      userName = "".concat(user.firstName, " ").concat(user.lastName);
  return _react["default"].createElement("div", {
    className: "activity-item"
  }, _react["default"].createElement("div", {
    className: "activity-item__side"
  }, _react["default"].createElement(_uiKit.Icon, {
    name: "video",
    color: "white",
    size: 20
  }), _react["default"].createElement("div", {
    className: "activity-item__side__line"
  })), _react["default"].createElement("div", {
    className: "activity-item__content"
  }, _react["default"].createElement("p", {
    className: "activity-item__content__action"
  }, "".concat(action, " by ").concat(userName.toUpperCase())), _react["default"].createElement("p", {
    className: "activity-item__content__date"
  }, (0, _moment["default"])(createdAt).calendar(null, {
    sameDay: "[TODAY] [at] HH:MMa",
    lastDay: "[YESTERDAY] [at] HH:MMa",
    sameElse: "MMM DD [at] HH:MMa"
  }))));
}

var _default = (0, _react.memo)(ActivityItem);

exports["default"] = _default;